(function($) {

    $(document).gp_ready(function(){
        $('.slider-bullets, .slider-bullets-store').each(function (){
            var delay = $(this).data('delay');
            if (delay.d){
                $(this).find('.swiper-pagination-bullet').css('animation-duration', parseInt(delay.d) + 'ms');
            }
        });
    });

})(jQuery);